module.exports = __webpack_public_path__ + "img/20200609_132529.0209a87c.jpg";